import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface FtSnackBarMessage {
    title?: string;
    message?: string;
    icon?: string;
    actionLabel?: string;
    type?: 'WARNING' | 'INFO' | 'SUCCESS';
}

@Component({
    selector: 'ft-snack-bar',
    templateUrl: './snack-bar.html',
    styleUrl: './snack-bar.scss',
    imports: [MatIconModule, MatButtonModule],
})
export class FtSnackBar {
    public data: FtSnackBarMessage = inject(MAT_SNACK_BAR_DATA);

    #snackRef = inject(MatSnackBarRef);

    onAction() {
        this.#snackRef.dismissWithAction();
    }
}
